
export const START_UPLOAD = 'upload/START_UPLOAD';
export const STEP_UPLOAD = 'upload/STEP_UPLOAD';
export const FINISH_UPLOAD = 'upload/FINISH_UPLOAD';
export const ERROR_UPLOAD = 'upload/ERROR_UPLOAD';
export const RESET_UPLOAD = 'upload/RESET_UPLOAD';

export const startUpload = (total: number) => ({
  type: START_UPLOAD,
  payload: { total },
});

export const stepUpload = (current: number, total: number, currentFile?: string, failed: any[] = []) => ({
  type: STEP_UPLOAD,
  payload: { current, total, currentFile, failed },
});

export const finishUpload = () => ({ type: FINISH_UPLOAD });
export const errorUpload = () => ({ type: ERROR_UPLOAD });
export const resetUpload = () => ({ type: RESET_UPLOAD });
